import script from "./CollectEmailWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./CollectEmailWidget.vue?vue&type=script&setup=true&lang=js"

import "./CollectEmailWidget.vue?vue&type=style&index=0&id=066678dd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-066678dd"]])

export default __exports__